import type Validator from '../../models/Validator';

const PhoneValidator: Validator = class {
  static isValid(value) {
    if (value) {
      return /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(value);
      //https://stackoverflow.com/questions/16699007/regular-expression-to-match-standard-10-digit-phone-number/16702965#16702965
    }

    return false;
  }

  static getError() {
    return null;
  }
};

export default PhoneValidator;
